export const STORE_TYPES = [
  {
    id: 'restaurant',
    label: '🍽️ Restaurant',
    categories: ['Appetizers', 'Main Courses', 'Soups & Salads', 'Side Dishes', 'Desserts', 'Beverages', 'Specials', 'Kids Menu', 'Other'],
    capabilities: { hasMenu: true, hasDelivery: true, hasDigital: false, hasRides: false },
  },
  {
    id: 'clothing',
    label: '👕 Clothing Store',
    categories: ['Tops', 'Bottoms', 'Dresses', 'Outerwear', 'Activewear', 'Swimwear', 'Accessories', 'Shoes', 'Underwear', 'Other'],
    capabilities: { hasMenu: false, hasDelivery: true, hasDigital: false, hasRides: false },
  },
  {
    id: 'electronics',
    label: '💻 Electronics',
    categories: ['Smartphones', 'Laptops', 'Tablets', 'Audio', 'Accessories', 'Gaming', 'Cameras', 'Wearables', 'Components', 'Other'],
    capabilities: { hasMenu: false, hasDelivery: true, hasDigital: true, hasRides: false },
  },
  {
    id: 'home',
    label: '🏠 Home & Garden',
    categories: ['Furniture', 'Decor', 'Kitchen', 'Bedding', 'Bath', 'Storage', 'Tools', 'Garden', 'Lighting', 'Other'],
    capabilities: { hasMenu: false, hasDelivery: true, hasDigital: false, hasRides: false },
  },
  {
    id: 'sports',
    label: '⚽ Sports & Outdoors',
    categories: ['Equipment', 'Footwear', 'Apparel', 'Accessories', 'Fitness', 'Camping', 'Cycling', 'Water Sports', 'Other'],
    capabilities: { hasMenu: false, hasDelivery: true, hasDigital: false, hasRides: false },
  },
  {
    id: 'beauty',
    label: '💄 Health & Beauty',
    categories: ['Skincare', 'Makeup', 'Hair Care', 'Fragrance', 'Bath & Body', 'Tools', "Men's Grooming", 'Wellness', 'Other'],
    capabilities: { hasMenu: false, hasDelivery: true, hasDigital: false, hasRides: false },
  },
  {
    id: 'books',
    label: '📚 Books & Media',
    categories: ['Fiction', 'Non-Fiction', "Children's", 'Textbooks', 'Comics', 'Magazines', 'Music', 'Movies', 'Other'],
    capabilities: { hasMenu: false, hasDelivery: true, hasDigital: true, hasRides: false },
  },
  {
    id: 'toys',
    label: '🎮 Toys & Games',
    categories: ['Action Figures', 'Board Games', 'Educational', 'Outdoor', 'Puzzles', 'Video Games', 'Dolls', 'Building Sets', 'Other'],
    capabilities: { hasMenu: false, hasDelivery: true, hasDigital: false, hasRides: false },
  },
  {
    id: 'automotive',
    label: '🚗 Automotive',
    categories: ['Parts', 'Accessories', 'Tools', 'Car Care', 'Interior', 'Exterior', 'Performance', 'Fluids', 'Other'],
    capabilities: { hasMenu: false, hasDelivery: true, hasDigital: false, hasRides: false },
  },
  {
    id: 'art',
    label: '🎨 Collectibles & Art',
    categories: ['Paintings', 'Sculptures', 'Prints', 'Photography', 'Antiques', 'Trading Cards', 'Memorabilia', 'Crafts', 'Other'],
    capabilities: { hasMenu: false, hasDelivery: true, hasDigital: true, hasRides: false },
  },
  {
    id: 'services',
    label: '🔧 Services',
    categories: ['Professional', 'Home', 'Personal Care', 'Education', 'Health', 'Creative', 'Technology', 'Automotive', 'Other'],
    capabilities: { hasMenu: false, hasDelivery: false, hasDigital: false, hasRides: true },
  },
  {
    id: 'other',
    label: '📦 Others',
    categories: ['Other'],
    capabilities: { hasMenu: false, hasDelivery: true, hasDigital: true, hasRides: false },
  },
];

export const JOB_TYPES = [
  { id: 'rides',       label: 'Rides',        icon: '🚗', description: 'Limo, transport & driver jobs' },
  { id: 'home_repair', label: 'Home Repair',   icon: '🔧', description: 'Plumbing, electrical, carpentry' },
  { id: 'cleaning',    label: 'Cleaning',      icon: '🧹', description: 'House, office, deep clean' },
  { id: 'moving',      label: 'Moving',        icon: '📦', description: 'Moving & hauling help' },
  { id: 'delivery',    label: 'Delivery',      icon: '🚚', description: 'Package & courier delivery' },
  { id: 'tutoring',    label: 'Tutoring',      icon: '📚', description: 'Education & coaching' },
  { id: 'pet_care',    label: 'Pet Care',      icon: '🐾', description: 'Dog walking, pet sitting' },
  { id: 'handyman',    label: 'Handyman',      icon: '🛠️', description: 'General odd jobs & repairs' },
  { id: 'beauty',      label: 'Beauty & Hair', icon: '💇', description: 'Styling, nails, grooming' },
  { id: 'tech',        label: 'Tech Support',  icon: '💻', description: 'IT help & device repair' },
  { id: 'events',      label: 'Events',        icon: '🎉', description: 'Catering, setup, photography' },
  { id: 'other',       label: 'Other',         icon: '💼', description: 'Any other service or job' },
];

export const SERVICE_CATEGORIES = [
  'Professional Services', 'Home Services', 'Personal Care', 'Education & Tutoring',
  'Health & Wellness', 'Creative Services', 'Technology Services', 'Automotive Services',
  'Event Services', 'Consulting', 'Other',
];

// jobType id → display label used as service section key in WelcomePage
export const JOB_TYPE_LABEL = Object.fromEntries(
  JOB_TYPES.map(j => [j.id, `${j.icon} ${j.label}`])
);

export const getStoreTypeById = (id) =>
  STORE_TYPES.find(t => t.id === id) ?? STORE_TYPES[STORE_TYPES.length - 1];

export const getCategoriesForStoreType = (storeTypeId, isService = false) => {
  // Services always get the generic service category list — a shop's storeType
  // (clothing, restaurant, etc.) describes its PRODUCTS, not services it offers,
  // so falling through to storeType-specific categories here would show product
  // categories (e.g. "Tops, Bottoms, Dresses") as service options.
  if (isService) return SERVICE_CATEGORIES;
  if (storeTypeId === 'other') {
    const all = STORE_TYPES
      .filter(t => t.id !== 'other' && t.id !== 'services')
      .flatMap(t => t.categories)
      .filter(c => c !== 'Other');
    return [...new Set(all), 'Entertainment', 'Miscellaneous', 'Other'];
  }
  const base = getStoreTypeById(storeTypeId)?.categories ?? ['Other'];
  return [...base.filter(c => c !== 'Other'), 'Entertainment', 'Miscellaneous', 'Other'];
};
